module.exports = __webpack_public_path__ + "img/InterestsAndFollowUps.5e038ba6.svg";